(function ($) {
  $(document).ready(function() {
    $('.course-product-form').each(function() {
      taa_course_credits_update(this);
    });
    $('.course-product-form .checkbox-holder input').change(function() {
      taa_course_credits_update($(this).closest('form')[0]);
    });
  });
  
  function taa_course_credits_update(form) {
    var checked = $('.checkbox-holder input:checked', form);
    var credits = 0;
    var price = 0;
    checked.each(function() {
      credits += parseFloat($(this).data('credits'));
      price += $(this).data('price');
    });
    var sum = $('.checkbox-sum', form);
    if (sum.data('price') != price || sum.data('credits') != credits) {
      var price_element = sum.find('.price');
      price_element.fadeOut(400, function() {
        price_element.fadeIn();
        price_element.text(Shopify.formatMoney(price));
      });
      var credits_element = sum.find('.credits');
      credits_element.fadeOut(400, function() {
        credits_element.fadeIn();
        credits_element.text(credits.toFixed(2));
      });
    }
  }
}) (jQuery);